import { render, staticRenderFns } from "./FooterDesktop.vue?vue&type=template&id=4300006b&scoped=true&"
import script from "./FooterDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FooterDesktop.vue?vue&type=style&index=0&id=4300006b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300006b",
  null
  
)

export default component.exports